import { DEMO_EXAMS } from '../contexts/DemoContext';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const IS_DEMO = process.env.REACT_APP_DEMO_MODE === 'true';

export const getExam = async (practiceId, patientId, caseId) => {
  if (IS_DEMO) {
    return DEMO_EXAMS[caseId] || {};
  }
  const ref = doc(db, 'practices', practiceId, 'patients', patientId, 'cases', caseId, 'exam', 'data');
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : {};
};

export const saveExamSection = async (practiceId, patientId, caseId, sectionId, data) => {
  if (IS_DEMO) {
    // Update in-memory demo data
    if (!DEMO_EXAMS[caseId]) DEMO_EXAMS[caseId] = {};
    DEMO_EXAMS[caseId][sectionId] = data;
    return;
  }
  const ref = doc(db, 'practices', practiceId, 'patients', patientId, 'cases', caseId, 'exam', 'data');
  await setDoc(ref, { [sectionId]: data }, { merge: true });
};
